/**
 * Constant values for EditorManager
 */
/**
 * Image plugin events
 *
 * @hidden
 */
export var IMAGE = 'INSERT-IMAGE';
export var AUDIO = 'INSERT-AUDIO';
export var VIDEO = 'INSERT-VIDEO';
export var TABLE = 'INSERT-TABLE';
export var LINK = 'INSERT-LINK';
export var INSERT_ROW = 'INSERT-ROW';
export var INSERT_COLUMN = 'INSERT-COLUMN';
export var DELETEROW = 'DELETE-ROW';
export var DELETECOLUMN = 'DELETE-COLUMN';
export var REMOVETABLE = 'REMOVE-TABLE';
export var TABLEHEADER = 'TABLE-HEADER';
export var TABLE_VERTICAL_ALIGN = 'TABLE_VERTICAL_ALIGN';
export var TABLE_MERGE = 'TABLE_MERGE';
export var TABLE_VERTICAL_SPLIT = 'TABLE_VERTICAL_SPLIT';
export var TABLE_HORIZONTAL_SPLIT = 'TABLE_HORIZONTAL_SPLIT';
export var TABLE_STYLES = 'TABLE_STYLES';
export var TABLE_BACKGROUND_COLOR = 'TABLE_BACKGROUND_COLOR';
export var TABLE_MOVE = 'TABLE_MOVE';
/**
 * Alignments plugin events
 *
 * @hidden
 */
export var ALIGNMENT_TYPE = 'alignment-type';
/**
 * LineHeight plugin events
 *
 * @hidden
 */
export var LINE_HEIGHT_TYPE = 'line-height-type';
/**
 * Indents plugin events
 *
 * @hidden
 */
export var INDENT_TYPE = 'indent-type';
/**
 * Constant tag names
 *
 * @hidden
 */
export var DEFAULT_TAG = 'p';
/**
 * @hidden
 */
export var BLOCK_TAGS = ['address', 'article', 'aside', 'audio', 'blockquote',
    'canvas', 'details', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer',
    'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'li', 'main', 'nav',
    'noscript', 'ol', 'output', 'p', 'pre', 'section', 'table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'tr', 'ul', 'video', 'body'];
/**
 * @hidden
 */
export var IGNORE_BLOCK_TAGS = ['td', 'th'];
/**
 * @hidden
 */
export var TABLE_BLOCK_TAGS = ['table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'tr'];
/**
 * Selection plugin events
 *
 * @hidden
 */
export var SELECTION_TYPE = 'selection-type';
/**
 * Insert HTML plugin events
 *
 * @hidden
 */
export var INSERTHTML_TYPE = 'inserthtml-type';
/**
 * Insert Text plugin events
 *
 * @hidden
 */
export var INSERT_TEXT_TYPE = 'insert-text-type';
/**
 * Clear Format HTML plugin events
 *
 * @hidden
 */
export var CLEAR_TYPE = 'clear-type';
/**
 * Self closing tags
 *
 * @hidden
 */
export var SELF_CLOSING_TAGS = ['area', 'base', 'br', 'embed', 'hr', 'img', 'input', 'param', 'source', 'track', 'wbr', 'iframe', 'td', 'table'];
/**
 * Source
 *
 * @hidden
 */
export var PASTE_SOURCE = ['word', 'excel', 'onenote'];
/**
 * @hidden
 */
export var ALLOWED_TABLE_BLOCK_TAGS = ['article', 'aside', 'blockquote', 'body', 'canvas', 'details', 'div', 'fieldset', 'figure', 'footer', 'form', 'header', 'li', 'main', 'nav', 'noscript', 'section'];
